<template>
  <div id="app" class="application transparent">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue